import { render, staticRenderFns } from "./DisciplinaryViolationEdit.vue?vue&type=template&id=be2b9cf8"
import script from "./DisciplinaryViolationEdit.vue?vue&type=script&lang=js"
export * from "./DisciplinaryViolationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports